module.exports = __webpack_public_path__ + "static/img/p5.3386af4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p5.png
// module id = 247
// module chunks = 1